// Chakra imports
import { Flex, Alert, Image, useColorModeValue  } from '@chakra-ui/react';

import tracking from 'assets/img/tracking.png';

export default function EmptyState(props: {
    expediente: string;
}) {
	const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
	const textColorSecondary = 'secondaryGray.600';
    const textColor = useColorModeValue("navy.700", "white"); 
    
    const mensajeExpediente = props.expediente && props.expediente !== '' 
    ? `Lo sentimos pero no hemos podido encontrar información para el expediente: ${props.expediente}. Por favor verifica que el número de expediente sea valido y si es asi por favor intentan mas tarde.`
    : `No hemos recibido ningún número de expediente para realizar la búsqueda por favor verifica he intenta nuevamente.`

	return (
        <Flex flexDirection={{ base: 'column' }}>
            <Image src={tracking} h={{ base: '120px' }}  w={{ base: '209px' }}  mb='10px'/>
            <Flex >
                <Alert m="10px"  variant='left-accent'>{mensajeExpediente}</Alert>            
            </Flex>        
        </Flex>          
	);
}
